import { useEffect, useRef } from "react";

type Callback = () => void;

export const useInterval = (
  callback: Callback,
  delay: number
): ReturnType<typeof setInterval> | undefined => {
  const timer = useRef<ReturnType<typeof setInterval>>();
  const savedCallback = useRef<Callback>();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback?.current();
    }

    if (delay !== null) {
      timer.current = setInterval(tick, delay);

      return () => clearInterval(timer.current);
    }
  }, [delay]);

  return timer.current;
};
